import React, { useMemo } from 'react';

// TODO: check types, its temporary
import DialogTitleMui from '@mui/material/DialogTitle';
import IconButtonMui from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';

const DialogTitle = ({ children, onClose, draggable, withCloseBtn, closeBtnProps = {}, ...rest }) => {
  const titleProps = useMemo(
    () =>
      draggable
        ? {
            style: { cursor: 'move' },
            id: 'draggable-dialog-title',
          }
        : {},
    [draggable],
  );

  return (
    <DialogTitleMui {...titleProps} {...rest}>
      <Box sx={{ pr: 3 }}>{children}</Box>
      {withCloseBtn && (
        <IconButtonMui
          aria-label="close"
          onClick={onClose}
          {...closeBtnProps}
          sx={{
            position: 'absolute',
            right: (theme) => theme.spacing(1),
            top: (theme) => theme.spacing(1),
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButtonMui>
      )}
    </DialogTitleMui>
  );
};

export default DialogTitle;
